import { render } from "./AddOrganisationDailyReportSubHeader.vue?vue&type=template&id=046463b0"
import script from "./AddOrganisationDailyReportSubHeader.vue?vue&type=script&lang=js"
export * from "./AddOrganisationDailyReportSubHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__